import { useMemo, useState } from "react";

import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Icon,
  type SvgComponentType,
} from "@newsela/angelou";

import { SubjectsMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenu/SubjectsMenuPopout";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import {
  getSubjectsButtonCss,
  subjectsMenuVisibilityBreakpointsCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenu/SubjectsMenu.styles";
import { useNavBarItemVisibility } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useNavBarItemsVisibilityControl";
import useShowProductsSection from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useShowProductsSection";
import { NavButtonWithPopoutText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText";

const MENU_ID = "nav-subjects-menu";

const SubjectsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
      }),
    [isOpen],
  );

  const onClickButton = () => setIsOpen((isOpen) => !isOpen);

  const { isVisible } = useNavBarItemVisibility();
  const showProductsSection = useShowProductsSection();

  if (showProductsSection)
    return (
      <NavButtonWithPopout
        id={MENU_ID}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        position={{ top: "4rem", left: 0 }}
        rootCustomCss={subjectsMenuVisibilityBreakpointsCss(
          isVisible("subjects-menu"),
        )}
        ButtonComponent={
          <Button
            onClick={onClickButton}
            ariaProps={buttonAriaProps}
            flavor={Button.flavors.incognito}
            __cssFor={getSubjectsButtonCss(isOpen)}
            dataProps={{
              "data-qa-selector": "global-nav-subjects-menu",
            }}
          >
            <NavButtonWithPopoutText>Subjects</NavButtonWithPopoutText>
            {isOpen ? (
              <Icon SvgComponent={ChevronUpSVG as SvgComponentType} />
            ) : (
              <Icon SvgComponent={ChevronDownSVG as SvgComponentType} />
            )}
          </Button>
        }
        PopoutComponent={<SubjectsMenuPopout />}
      />
    );
  return null;
};

SubjectsMenu.displayName = "SubjectsMenu";
export { SubjectsMenu };
